export default function(keys, deepVal) {
  keys.push(deepVal);
  const nested = keys.reduceRight((acc, x) => ({ [x]: acc }));
  return nested;
}
